<template>
  <div class="index-content">
    <img class="index-title" src="../../../assets/image/kjqg/index/index-title.png">
    <!-- <img class="header-logo" src="../../../assets/image/kjqg/index/index-logo.png"> -->
    <div class="header-logo">
      <div class="logo-img">
        <img v-if="schoolInfo" :src="schoolInfo.school_logo_light" />
      </div>
      <div class="lines"></div>
      <img class="zyk-imgs" src="../../../assets/image/kjqg/index/szzyk-img.png" />
    </div>
    <template>
      <div v-if="appsUserInfo && appsUserInfo.name" class="login-dropdown-box">
        <div class="login-after">{{ appsUserInfo.name }}</div>
        <div class="login-sub-box">
          <template v-if="
                appsUserInfo.user_type == 2 ||
                (appsUserInfo.user_type == 1 && appsUserInfo.role_ids)
              ">
            <div class="hover-item">
              <a :href="`${services.BEIKE_SERVER}/${school_code}/sz/school/resource`" target="_blank">校内共建资源库</a>
            </div>
            <div class="hover-item">
              <a :href="`${services.BEIKE_SERVER}/${school_code}/lesson/resource`" target="_blank">备课资源库</a>
            </div>
            <div class="hover-item">
              <a :href="`${services.BEIKE_SERVER}/${school_code}/lesson/works`" target="_blank">协同备课</a>
            </div>
            <div class="hover-item">
              <a :href="`${services.BEIKE_SERVER}/${school_code}/sz/favorite`" target="_blank">资源收藏</a>
            </div>
          </template>
          <template v-if="
                appsUserInfo.user_type == 2 ||
                (appsUserInfo.user_type == 1 && appsUserInfo.role_ids == 2)
              ">
            <div class="hover-item">
              <a :href="`${services.BEIKE_SERVER}/${school_code}/manage/user`" target="_blank">用户管理</a>
            </div>
          </template>
          <div class="login-lines"></div>
          <div class="hover-item">
            <a :href="`${services.APPS_WEB}/${school_code}/worker`" target="_blank">信息服务中心</a>
          </div>
          <div class="hover-item">
            <a :href="`${services.APPS_WEB}/${school_code}/userInfo`" target="_blank">个人信息设置</a>
          </div>
          <div v-if="!isMobile" class="hover-item">
            <a :href="`${services.APPS_WEB}/${school_code}/editPassword`" target="_blank">修改密码</a>
          </div>
          <div class="hover-item" @click="logoutEvent">
            <a href="javascript:;">退出</a>
          </div>
        </div>
      </div>
      <template v-else>
        <div class="btns">
          <div class="login-btn" @click="loginModal(true)">登录</div>
          <a class="free-btn" :href="services.YXT_GW + '/need'" target="_blank">申请免费试用</a>
        </div>
      </template>
    </template>
    <!-- <Login></Login> -->
  </div>

</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
// import Login from "../../../components/Login.vue";
import services from "../../../assets/js/services";
import utils from "../../../assets/js/utils";
export default {
  // components: {
  //   Login,
  // },
  data() {
    return {
      services,
      isMobile: utils.isMobile(),
      school_code: localStorage.getItem("schoolCode"),
    };
  },
  computed: {
    ...mapState({
      loginVisible: (state) => state.appsLogin.loginVisible,
      appsUserInfo: (state) => state.appsLogin.appsUserInfo,
      schoolInfo: (state) => state.appsLogin.schoolInfo,
    }),
  },
  created() {
    this.getAppsLoginUserInfo();
    this.getLoginSchoolInfo({ school_code: this.school_code, label: 'kcsz' })
  },
  methods: {
    ...mapMutations([
      "setSearchKeyWord",
      "setAppsLoginVisible",
      "setSearchSzzykData",
      "setSearchElementData",
      "resetSzzykTotal",
    ]),
    ...mapActions([
      "getAppsImageCaptcha",
      "getLoginSchoolInfo",
      "getAppsLoginUserInfo",
      "requestAppsLogout",
      "goAppsDetailsBeforeLogin",
      "schoolLoginRedirect",
    ]),
    loginModal(val) {
      let that = this;
      // 如果需要统一登录,跳转
      let param = {
        format: "json",
        school_code: that.school_code,
        from: window.location.href,
      };
      that.schoolLoginRedirect(param).then((res) => {
        if (
          res.code == "0000" &&
          res.data &&
          !(res.data.redirect.indexOf(services.APPS_WEB) > -1)
        ) {
          return window.open(res.data.redirect, "_self");
        } else {
          if (val) {
            that.getAppsImageCaptcha();
          }
          that.setAppsLoginVisible(val);
        }
      });
    },
    async logoutEvent() {
      let that = this;
      await that.requestAppsLogout().then(() => {
        this.$message.success("已退出登录");
      });
    },
    toNextSlide() {
      this.$emit("toNextSlide");
    },
  },
};
</script>

<style lang="less" scoped>
.index-content {
  width: 100%;
  height: 100%;
  background-image: url("../../../assets/image/kjqg/index/index-bg.png");
  background-position: center;
  background-size: cover;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  .index-title {
    max-width: 70.4vw;
    animation: titscale 2s;
  }
  .header-logo {
      position: absolute;
      top: 1.67vw;
      left: 3.3vw;
      display: flex;
      align-items: center;
      .logo-img {
        height: 50px;
        img {
          width: auto;
          height: 100%;
        }
      }
      .lines {
        width: 2px;
        height: 22px;
        margin: 0 25px;
        background-color: #FFF;
      }
      .zyk-imgs {
        height: 22px;
        width: auto;
      }
    }
  .login-dropdown-box {
    margin-left: 35px;
    height: 55px;
    line-height: 40px;
    position: absolute;
    top: 1.67vw;
    right: 145px;
    display: inline-block;
    .login-after {
      color: #ffffff;
      background: #d48432;
      font-size: 15px;
      display: inline-block;
      line-height: 32px;
      padding: 0 8px;
      min-width: 72px;
      &::after {
        display: inline-block;
        content: "";
        width: 7px;
        height: 5px;
        margin-left: 5px;
        background-image: url("../../../assets/image/common/up-icon.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100% auto;
        vertical-align: 3px;
        transition: background-image 0.3s;
      }
    }
    .login-sub-box {
      display: none;
      position: absolute;
      padding: 10px 20px;
      box-sizing: border-box;
      top: 45px;
      left: 50%;
      transform: translateX(-50%);
      width: 140px;
      text-align: left;
      background-color: transparent;
      box-shadow: 0px 1px 6px 0px rgba(130, 130, 130, 0.2);
      border-radius: 2px;
      transition: background-color 0.3s;
      z-index: 100;
      .hover-item {
        display: block;
        line-height: 26px;
        &:hover {
          background-color: #fff;
        }
        a {
          color: #393939;
          font-size: 12px;
          display: block;
          &:hover {
            color: #e64757;
            background-color: #fff;
          }
        }
      }
      .login-lines {
        width: 100%;
        height: 1px;
        background: #f3f4f5;
        margin: 5px 0;
      }
    }
    &:hover .login-after::after {
      background-image: url("../../../assets/image/common/down-icon.png");
      background-size: 100% auto;
      background-repeat: no-repeat;
      background-position: center;
    }
    &:hover .login-sub-box {
      display: block;
      background-color: #ffffff;
    }
  }
  .header-logo {
    display: flex;
    .left-logo {
      width: 418px;
      height: 60px;
      background-image: url("../../../assets/image/gjjs/index/nav-index/jyzx-logo.png");
      background-size: cover;
      background-repeat: no-repeat;
      cursor: pointer;
    }
  }
  .btns {
    display: flex;
    justify-content: flex-end;
    // padding: 0 5vw;
    top: 1.67vw;
    right: 3.3vw;
    position: absolute;

    .login-btn {
      margin-top: 5px;
      width: 72px;
      height: 32px;
      background: #d48432;
      font-size: 15px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 32px;
      text-align: center;
      margin-left: 53px;
      cursor: pointer;
    }
    .free-btn {
      // width: 7.1vw;
      padding: 0 15px;
      height: 32px;
      background: #146ED5;
      font-size: 15px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 32px;
      text-align: center;
      margin-top: 5px;
      margin-left: 0.5vw;
    }
  }
}
@keyframes titscale {
  0% {
    transform: scale(0.2);
  }

  100% {
    transform: scale(1);
  }
}
</style>